<!-- Button field selected - no event selection needed -->
<div class="form-group">
  <div class="row fields-group">
    <div class="col">
      <label class="input-label">{{ 'Button Event' | translate }}</label>
      <select name="buttonEventName" [(ngModel)]="buttonEventName" (change)="buttonEventNameChanged()" class="form-control">
        <option value="" disabled>{{ 'Choose here' | translate }}</option>
        <option *ngFor="let event of buttonEvents" [value]="event.key">{{ event.name }}</option>
      </select>
    </div>
  </div>
</div>